var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-archive"},[_c('v-icon',[_vm._v("mdi-magnify")]),_c('span',{staticClass:"search-archive__content"},[_vm._v(" Looking for a historical record? "),_c('button',{staticClass:"search-archive__cta",on:{"click":_vm.handleClick}},[_vm._v(" Search archive ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }